/**
 * Pave API
 * Pave API Documentation
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ChildTransactionModel { 
    commuteMode?: ChildTransactionModelCommuteModeEnum | null;
    id: string;
    type: object;
    date: string;
    amount: number;
    amountInMoney?: number;
    accountBalance: number;
    rewardStyle?: object;
    description?: string;
    commute: string | null;
    username: string;
}
export enum ChildTransactionModelCommuteModeEnum {
    car = 'car',
    bike = 'bike',
    walk = 'walk',
    scooter = 'scooter',
    transit = 'transit',
    carpool = 'carpool',
    internalShuttle = 'internalShuttle'
};



